var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define('charts/multichart',["require", "exports", "../tracks/track-enabled", "../tracks/track-state", "../util/bounds", "../util/convert", "./basechart", "./charthelpers", "./layers/diagonals", "./layers/starred-layer", "./layers/distancelayer", "./layers/metricslayer", "./layers/profilefocus", "./unroll"], function (require, exports, trackEnabled, trackState, bounds_1, convert_1, basechart_1, charthelpers_1, diagonals_1, starred_layer_1, distancelayer_1, metricslayer_1, profilefocus_1, unroll) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MultiChart = void 0;
    var margin = {
        bottom: 2,
        top: 15,
        right: 2,
        left: 50
    };
    var MultiChart = /** @class */ (function (_super) {
        __extends(MultiChart, _super);
        /** Initial chart setup */
        function MultiChart() {
            var _this = _super.call(this, "#flight-profile", margin, 1) || this;
            _this.options = {
                fx: function (d) { return d && (_this.isUnrolled ? d.distance : d.x); },
                fy: function (d) { return d && d.y; },
                inner: function () { return ({
                    x: { min: 0, max: -_this.zoomMin },
                    y: { min: _this.zoomMin, max: 0 }
                }); },
                outer: function () { return ({
                    x: { min: 0, max: 40000 },
                    y: { min: -12000, max: 5000 }
                }); }
            };
            _this.starredLayer = new starred_layer_1.StarredLayer(_this.options);
            _this.distanceLayer = new distancelayer_1.DistanceLayer(_this.options);
            _this.focusLayer = new profilefocus_1.ProfileFocus(_this.options);
            _this.metricsLayer = new metricslayer_1.MetricsLayer();
            _this.isUnrolled = false;
            _this.scaleFactor = 1;
            _this.zoomSlider = null;
            // Min and max zoom, in local units
            _this.zoomMin = convert_1.default.system === "metric" ? -300 : -1000;
            _this.zoomMax = convert_1.default.system === "metric" ? -100 : -300;
            if (!_this.svg) {
                return _this;
            }
            // Setup axes
            _this.xAxis.gridLines = true;
            _this.xAxis.axis
                .tickFormat(function (d) { return Math.floor(d) + convert_1.default.distance.label; });
            _this.yAxis[0].gridLines = true;
            _this.yAxis[0].axis
                .tickFormat(function (d) { return Math.floor(d) + convert_1.default.distance.label; });
            // Add ChartLayers
            _this.addLayer(new diagonals_1.Diagonals(1));
            _this.addLayer(_this.starredLayer);
            _this.addLayer(_this.distanceLayer);
            _this.addLayer(_this.metricsLayer);
            _this.addLayer(_this.focusLayer);
            // Listen for mouse movements
            var self = _this;
            _this.layers.overlay
                .on("mouseout", function () { return _this.unfocus(); })
                .on("mousemove", function (evnt) { return _this.mousemove(evnt); });
            // Setup zoom slider
            _this.zoomSlider = d3.select("#zoom-slider")
                .attr("min", 0)
                .attr("max", 255)
                .property("value", 0)
                .on("input", function () { self.updateZoom(this); });
            // Bind unroll toggle
            unroll.init(_this);
            // On window resize, re-draw the chart
            window.addEventListener("resize", function () { return _this.update(); });
            // Listen for updates
            trackState.focusUpdates.subscribe(function (point, track) { return _this.focusLayer.drawFocus(point, track); });
            trackState.trimUpdates.subscribe(function () { return _this.update(); });
            trackState.highlight.subscribe(function () { return _this.distanceLayer.update(_this); });
            trackEnabled.trackEnabled.subscribe(function () { return _this.update(); });
            trackEnabled.trackDisabled.subscribe(function () { return _this.update(); });
            // Initial chart update
            _this.update();
            return _this;
        }
        /**
         * Update chart data
         */
        MultiChart.prototype.update = function () {
            if (!this.svg)
                return;
            // Scale the domain of the data
            var bounds = (0, charthelpers_1.getBounds)(trackEnabled.enabled, this.options);
            bounds = (0, bounds_1.cleanBounds)(bounds, this.options.inner(), this.options.outer());
            bounds = (0, bounds_1.squareBounds)(bounds, this.width(), this.height());
            // Zoom (from -300ft to bounds.y.min)
            if (this.zoomSlider && this.zoomSlider.size() > 0) {
                var scaleMax = bounds.y.min / this.zoomMax;
                // zoom [0,255] -> sf [1,scaleMax]
                var zoomPercent = this.zoomSlider.property("value") / this.zoomSlider.property("max");
                this.scaleFactor = 1 + (scaleMax - 1) * zoomPercent * zoomPercent;
            }
            var xMax = bounds.x.min + (bounds.x.max - bounds.x.min) / this.scaleFactor;
            var yMin = bounds.y.max - (bounds.y.max - bounds.y.min) / this.scaleFactor;
            this.xAxis.scale.domain([bounds.x.min, xMax]);
            this.yAxis[0].scale.domain([yMin, bounds.y.max]);
            // Do the chart update AFTER we've updated the axes
            _super.prototype.update.call(this);
        };
        MultiChart.prototype.setUnroll = function (isUnrolled) {
            this.isUnrolled = isUnrolled;
            this.distanceLayer.transitionNext();
            this.update();
        };
        /** Zoom to fixed altitude */
        MultiChart.prototype.zoomTo = function (altitude) {
            var bounds = (0, charthelpers_1.getBounds)(trackEnabled.enabled, this.options);
            bounds = (0, bounds_1.cleanBounds)(bounds, this.options.inner(), this.options.outer());
            bounds = (0, bounds_1.squareBounds)(bounds, this.width(), this.height());
            var scaleMax = bounds.y.min / this.zoomMax;
            var yMin = altitude * convert_1.default.distance.units;
            var scaleFactor = (bounds.y.max - bounds.y.min) / (bounds.y.max - yMin);
            var zoomPercent = Math.sqrt((scaleFactor - 1) / (scaleMax - 1));
            this.zoomSlider.property("value", 255 * zoomPercent);
            this.update();
        };
        MultiChart.prototype.mousemove = function (evnt) {
            var _a;
            var x0 = this.xAxis.scale.invert(d3.pointer(evnt)[0]);
            var y0 = this.yAxis[0].scale.invert(d3.pointer(evnt)[1]);
            var closest = (0, charthelpers_1.closestPoint)(trackEnabled.enabled, this.options, x0, y0);
            // Notify other focus listeners
            if (closest) {
                // Check distance in screen space
                if ((0, charthelpers_1.checkDistance)(this, this.options, closest[0], evnt)) {
                    (_a = trackState.focusUpdates).post.apply(_a, closest);
                }
                else {
                    this.unfocus();
                }
            }
            else {
                this.unfocus();
            }
        };
        /**
         * Unfocus when the mouse moves off the chart
         */
        MultiChart.prototype.unfocus = function () {
            trackState.focusUpdates.post(undefined);
        };
        /**
         * Handle zoom slider
         * @param input the <input type="range"> slider
         */
        MultiChart.prototype.updateZoom = function (input) {
            this.scaleFactor = Number(input.min) / Number(input.value);
            this.unfocus();
            this.update();
        };
        return MultiChart;
    }(basechart_1.BaseChart));
    exports.MultiChart = MultiChart;
});
//# sourceMappingURL=/assets/javascripts/charts/multichart.js.map;
